<template>
    <div>
        <v-container class="mt-lg-10" fluid>
            <v-row dense>
                <v-col>
                    <v-card>
                        <v-app-bar color="#81c342" dark>
                            <v-icon class="mr-3">mdi-filter</v-icon>
                            <v-toolbar-title>Filters</v-toolbar-title>
                        </v-app-bar>
                        <v-container fluid>
                            <v-row dense>

                                <v-col cols="12" lg="3" md="3">
                                    <v-skeleton-loader :loading="loadingFilterData" transition="scale-transition"
                                                       type="card-heading">
                                        <v-select :items="amountRangeDropdownData" :label="filterBoxLabel.amount" chips
                                                  deletable-chips dense outlined small-chips
                                                  v-model="filterBox.loanAmount"></v-select>
                                    </v-skeleton-loader>
                                </v-col>

                                <v-col cols="12" lg="3" md="3">
                                    <v-skeleton-loader :loading="loadingFilterData" transition="scale-transition"
                                                       type="card-heading">
                                        <v-select :items="statusDropdownData" :label="filterBoxLabel.gfiStatus" chips
                                                  deletable-chips dense outlined small-chips
                                                  v-model="filterBox.gfiStatus"></v-select>
                                    </v-skeleton-loader>
                                </v-col>

                                <v-col cols="12" lg="3" md="3">
                                    <v-skeleton-loader :loading="loadingFilterData" transition="scale-transition"
                                                       type="card-heading">
                                        <v-menu :close-on-content-click="false" :nudge-right="40" min-width="290px"
                                                offset-y transition="scale-transition" v-model="menu1">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field label="Start Date" append-icon="mdi-calendar" clearable
                                                              dense outlined readonly v-model="filterBox.startDate"
                                                              v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker color="#81c342" :max="date" @input="menu1 = false"
                                                           v-model="filterBox.startDate"></v-date-picker>
                                        </v-menu>
                                    </v-skeleton-loader>
                                </v-col>

                                <v-col cols="12" lg="3" md="3">
                                    <v-skeleton-loader :loading="loadingFilterData" transition="scale-transition"
                                                       type="card-heading">
                                        <v-menu :close-on-content-click="false" :nudge-right="40" min-width="290px"
                                                offset-y transition="scale-transition" v-model="menu2">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field label="End Date" append-icon="mdi-calendar" clearable
                                                              dense outlined readonly v-model="filterBox.endDate"
                                                              v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker color="#81c342" :max="date" :min="filterBox.startDate"
                                                           @input="menu2 = false"
                                                           v-model="filterBox.endDate"></v-date-picker>
                                        </v-menu>
                                    </v-skeleton-loader>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" lg="6" md="6"></v-col>
                                <v-col class="d-flex justify-lg-end justify-md-end justify-center" cols="12" lg="6"
                                       md="6">
                                    <v-skeleton-loader :loading="loadingFilterData" transition="scale-transition"
                                                       type="button">
                                        <v-btn @click="resetFilters" color="#49abad" dark>Reset</v-btn>
                                    </v-skeleton-loader>
                                    <v-skeleton-loader :loading="loadingFilterData" transition="scale-transition"
                                                       type="button">
                                        <v-btn @click="filterData" class="ml-3" color="#49abad" dark>Filter</v-btn>
                                    </v-skeleton-loader>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-container class="customersTablePadding" fluid>
            <v-row>
                <v-col>
                    <v-card>
                        <v-app-bar color="#81c342" dark>
                            <v-icon class="mr-3">mdi-account-group</v-icon>
                            <v-toolbar-title v-if="showTableHeading">
                              <span v-show="userType=='SME'">SME</span>
                              <span v-show="userType=='MIKRO'">MIKRO</span>
                            </v-toolbar-title>
                          <v-toolbar-title v-else>
                            <span>List of Test Reports</span>
                          </v-toolbar-title>
                            <v-row justify="end">
                                <v-dialog max-width="450" persistent v-model="appliedDialog">
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="#1c3d50" class="hidden-sm-and-down text-left" dark v-on="on">View Applied Filters</v-btn>
                                        <v-btn color="#1c3d50" class="hidden-md-and-up" dark v-on="on">
                                          <v-icon>
                                            mdi-filter
                                          </v-icon></v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title class="headline">Filters Applied</v-card-title>
                                        <v-card-text>
                                            <v-simple-table>
                                                <template v-slot:default>
                                                    <tbody>
                                                    <tr>
                                                        <td>{{ filterBoxLabel.amount }}</td>
                                                        <td>:</td>
                                                        <td v-if="!appliedFilters.amount">All Amount Ranges</td>
                                                        <td v-else>
                                                            <span :key="amount" v-for="amount in amountRangeDropdownData">
                                                                <span v-if="appliedFilters.amount === amount.value">{{amount.text}}</span>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{ filterBoxLabel.gfiStatus }}</td>
                                                        <td>:</td>
                                                        <td v-if="!appliedFilters.status">All Status</td>
                                                        <td v-else>
                                                            <span :key="status" v-for="status in statusDropdownData">
                                                                <span v-if="appliedFilters.status === status.value">{{status.text}}</span>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{ filterBoxLabel.startDate }}</td>
                                                        <td>:</td>
                                                        <td v-if="!appliedFilters.startDate">All Dates</td>
                                                        <td v-else>
                                                            {{ appliedFilters.startDate }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                      <td>{{ filterBoxLabel.endDate }}</td>
                                                      <td>:</td>
                                                      <td v-if="!appliedFilters.endDate">All Dates</td>
                                                      <td v-else>
                                                        {{ appliedFilters.endDate }}
                                                      </td>
                                                    </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-card-text>
                                        <v-card-actions>
                                            <div class="flex-grow-1"></div>
                                            <v-btn @click="appliedDialog = false" color="green darken-1" text>Close</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-row>
                        </v-app-bar>
                        <v-container class="containerStyling">
                            <v-row>
                        <span :key="index" v-for="(headers, index) in headers">
                           <v-col v-if="headers.toggle">
                              <v-checkbox :label="headers.text" color="primary"
                                          v-model="headers.selectedCheckbox"
                                          v-on:change="recordTicks()"/>
                           </v-col>
                        </span>
                            </v-row>
                        </v-container>
                        <v-card>
                            <v-skeleton-loader :loading="tableDataLoading" transition="scale-transition"
                                               type="table-tbody">
                                <v-card-title>
                                    <v-row>
                                        <v-col md="7"></v-col>
                                        <v-text-field hide-details placeholder="Search" single-line
                                                      v-model="search"></v-text-field>
                                        <div class="pl-3 mt-2"></div>
                                        <v-btn @click="filterData" class="ma-2" dark color="#49abad">
                                            <v-icon dark>mdi-magnify</v-icon>
                                        </v-btn>
                                    </v-row>
                                </v-card-title>
                            </v-skeleton-loader>
                            <v-data-table :disable-sort="true" :footer-props="{
                            'items-per-page-options': pagination.itemPerPageOptions,'show-current-page':true}"
                                          :headers="filteredHeaders" :items="table.tableData"
                                          :options.sync="pagination" :server-items-length=table.totalLength
                                          @update:options="paginate" v-show="!tableDataLoading">
                                <template v-slot:item.loan_amount="{ item }">
                                    <span v-if="item.loan_amount">
                                        {{ item.loan_amount }}
                                    </span>
                                    <span class="text-center" v-else>
                                        <v-icon>mdi-minus</v-icon>
                                    </span>
                                </template>
                                <template v-slot:item.test_finish_time="{ item }">
                                    <span v-if="item.test_finish_time">
                                        {{ item.test_finish_time }}
                                    </span>
                                    <span class="text-center" v-else>
                                        <v-icon>mdi-minus</v-icon>
                                    </span>
                                </template>
                                <template v-slot:item.details="{ item }">
                                    <v-icon @click="editItem(item)" class="mr-2" color="#49abad" small
                                            v-if="!item.scoring_triggered_by_officer && item.status==='FINISHED'">
                                        mdi-square-edit-outline
                                    </v-icon>
                                    <v-icon class="mr-2" color="grey darken-2" small v-else>
                                        mdi-square-edit-outline
                                    </v-icon>
                                </template>
                                <template v-slot:item.applicationStatus="{ item }">
                                    {{ item.application_status_label }}
                                    <v-icon @click="editApplicationStatus(item)" class="mr-2" color="#49abad"
                                            small v-if="item.has_gfi_score">mdi-square-edit-outline
                                    </v-icon>
                                    <v-icon class="mr-2" color="grey darken-2" small v-if="!item.has_gfi_score">
                                        mdi-square-edit-outline
                                    </v-icon>
                                </template>
                                <template v-slot:item.scoring="{ item }">
                                    <v-icon @click="generateScore(item)" class="mr-2" color="#49abad" small
                                            v-if="item.ready_for_scoring && !item.scoring_triggered_by_officer">
                                        mdi-calculator
                                    </v-icon>
                                    <v-icon class="mr-2" color="grey darken-2" small
                                            v-if="!item.ready_for_scoring || (item.ready_for_scoring && item.scoring_triggered_by_officer)">
                                        mdi-calculator
                                    </v-icon>
                                </template>
                                <template v-slot:item.test_taker_score_overall_rating="{ item }">
                           <span v-if="item.test_taker_score_overall_rating">
                           {{ item.test_taker_score_overall_rating }}
                           </span>
                                    <span class="text-center" v-else>
                              <v-icon>mdi-minus</v-icon>
                           </span>
                                </template>
                                <template v-slot:item.report="{item}">
                           <span v-if="item.has_gfi_score">
                              <span v-if="checkArray(item._id,item.id_number,'BANK_REPORT')">
                                 <v-icon
                                         @click.native="downloadReport(item._id,item.id_number,'BANK_REPORT')"
                                         color="success">mdi-file-download</v-icon>
                              </span>
                              <span v-else>
                                 <v-progress-circular :size="20" color="#49abad"
                                                      indeterminate></v-progress-circular>
                              </span>
                           </span>
                                    <span v-else>
                              <v-icon>mdi-file-download</v-icon>
                           </span>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-card>
                </v-col>
            </v-row>
            <v-dialog max-width="450" persistent v-model="dialog" v-if="renderEditForm">
                <v-card>
                    <v-card-title class="headline">Edit Customer Information</v-card-title>
                    <v-card-text>
                        <ValidationObserver ref="observer" v-slot="{ passes}">
                            <form>
                                <v-skeleton-loader
                                        :loading="loading"
                                        transition="scale-transition"
                                        type="list-item-two-line">
                                    <ValidationProvider :rules="{required: true}"
                                                        v-slot="{errors, failedRules}">
                                        <v-select
                                                :error-messages="$translatedErrorMessages(failedRules,'gender')"
                                                :items="editGenderFilterDropdownData"
                                                item-text="text"
                                                item-value="value"
                                                label="Gender"
                                                chips
                                                deletable-chips
                                                small-chips
                                                v-model="editedItem.gender">
                                        </v-select>
                                    </ValidationProvider>
                                </v-skeleton-loader>

                                <v-skeleton-loader :loading="loading" transition="scale-transition"
                                                   type="list-item-two-line">
                                        <v-menu ref="menu" v-model="menu"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px">
                                            <template v-slot:activator="{ on }">
                                              <ValidationProvider :rules="{required: true }" v-slot="{errors, failedRules}">
                                                <v-text-field
                                                    :error-messages="$translatedErrorMessages(failedRules,'date')"
                                                    label="Date of Business Commencement" append-icon="mdi-calendar"
                                                              clearable readonly v-model="editedCommencementDate"
                                                              v-on="on"></v-text-field>
                                              </ValidationProvider>
                                            </template>

                      <v-date-picker color="#81c342" :max="date" v-model="editedItem.commencement_date"
                                     @input="menu = false"
                                     no-title scrollable>
                      </v-date-picker>
                    </v-menu>

                </v-skeleton-loader>
                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider :rules="{ required: true}"
                                      v-slot="{errors, failedRules}">
                    <v-select
                        :error-messages="$translatedErrorMessages(failedRules,'malaysianOwned')"
                        :items="malaysianOwnedItems"
                        item-text="text"
                        item-value="value"
                        label="Malaysian Owned"
                        chips
                        deletable-chips
                        small-chips
                        v-model="editedItem.malaysian_owned"
                    ></v-select>
                  </ValidationProvider>
                </v-skeleton-loader>
                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider :rules="{numeric: true, min_value: 1, max_value: 999999999}"
                                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'paidUpCapital')"
                        label="Paid-up Capital Amount "
                        prefix="RM"
                        v-model="editedItem.paid_up_capital">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>
                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider :rules="{ required: true}"
                                      v-slot="{errors, failedRules}">
                    <v-select
                        :error-messages="$translatedErrorMessages(failedRules,'businessSize')"
                        :items="businessSizeItems"
                        item-text="text"
                        item-value="value"
                        label="Size Of Business"
                        chips
                        deletable-chips
                        small-chips
                        v-model="editedItem.business_size"
                    ></v-select>
                  </ValidationProvider>
                </v-skeleton-loader>
                <v-skeleton-loader>
                  <ValidationProvider :rules="{ required: true}"
                                      v-slot="{errors, failedRules}">
                    <v-select
                        :error-messages="$translatedErrorMessages(failedRules,'natureOfBusiness')"
                        :items="editBusinessCategoryDropdownData"
                        item-text="text"
                        item-value="value"
                        label="Nature Of Business"
                        chips
                        deletable-chips
                        small-chips
                        v-model="editedItem.business_category"
                    ></v-select>
                  </ValidationProvider>
                </v-skeleton-loader>
                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider :rules="{required: true,  numeric: true, min_value:1, max_value:180}"
                                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'industryExperience')"
                        label="Years of Industry Experience"
                        v-model="editedItem.industry_experience">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>
                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider :rules="{required: true, numeric: true, min_value:1, max_value:1000}"
                                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'employeesCount')"
                        label="Full-Time Employees"
                        v-model="editedItem.employees_count">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>
                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider :rules="{ required: true, integer: true, min_value:-999999999, max_value:999999999}"
                                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'annualSales')"
                        label="Annual Sales Turnover" prefix="RM"
                        v-model="editedItem.annual_sales">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>
                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider :rules="{ required: true, integer: true, min_value:-999999999, max_value:editedItem.annual_sales?editedItem.annual_sales:999999999}"
                                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'annualProfit', [editedItem.annual_sales?editedItem.annual_sales:999999999])"
                        label="Annual Profit Before Tax"
                        prefix="RM"
                        v-model="editedItem.annual_profit">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>
                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider :rules="{required: true, numeric: true, min_value:1000, max_value:999999999}"
                                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'financingAmount')"
                        label="Loan Amount Required"
                        prefix="RM"
                        v-model="editedItem.loan_amount">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>
                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider :rules="{required: true,  numeric: true, min_value:1, max_value:180}"
                                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'tenureApplied')"
                        label="Financing Tenure"
                        suffix="Months"
                        v-model="editedItem.tenure_applied">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>
                              <v-skeleton-loader
                                  :loading="loading"
                                  transition="scale-transition"
                                  type="list-item-two-line">
                                <ValidationProvider :rules="{numeric: true, min_value:300, max_value:850}"
                                                    v-slot="{errors, failedRules}">
                                  <v-text-field
                                      :error-messages="$translatedErrorMessages(failedRules,'ctosRating')"
                                      label="CTOS/CCRIS Rating (if any)"
                                      v-model="editedItem.ctos_rating">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-skeleton-loader>
                              <v-skeleton-loader
                                  :loading="loading"
                                  transition="scale-transition"
                                  type="list-item-two-line">
                                <ValidationProvider :rules="{regex: /^\d*\.?\d*$/}"
                                                    v-slot="{errors, failedRules}">
                                  <v-text-field
                                      :error-messages="$translatedErrorMessages(failedRules,'cbrRating')"
                                      label="Credit Bureau Rating (if any)"
                                      v-model="editedItem.cbr_rating">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-skeleton-loader>
                <v-card-actions align="right">
                  <v-spacer></v-spacer>
                  <v-btn @click="clear" dark color="#49abad">Cancel</v-btn>
                  <v-skeleton-loader :loading="loading" transition="scale-transition" type="button">
                    <v-btn @click="passes(updatedItem)" class="ml-4" color="#49abad" dark>Save
                    </v-btn>
                  </v-skeleton-loader>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog max-width="450" persistent v-model="applicationStatusDialog">
        <v-card>
          <v-card-title class="headline">Update Application Status</v-card-title>
          <v-card-text>
            <ValidationObserver ref="observer" v-slot="{passes}">
              <form>
                <v-skeleton-loader :loading="loadingFilterData" transition="scale-transition"
                                   type="list-item-two-line">
                  <ValidationProvider :rules="{alpha_num: true, max: 20}"
                                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'applicationNumber')"
                        label="Application No. by FI"
                        v-model="editApplicationItem.application_number">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>
                <v-skeleton-loader
                    :loading="loadingFilterData"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider rules="required" v-slot="{errors, failedRules}">
                    <v-select
                        :error-messages="$translatedErrorMessages(failedRules,'customerApplicationStatus')"
                        :items="applicationStatusDropdownData"
                        item-text="text"
                        item-value="value"
                        label="Application Status"
                        v-model="editApplicationItem.application_status"
                    >
                    </v-select>
                  </ValidationProvider>
                </v-skeleton-loader>
                <div v-if="editApplicationItem.application_status==='A'">
                  <v-skeleton-loader
                      :loading="loadingFilterData"
                      transition="scale-transition"
                      type="list-item-two-line">
                    <ValidationProvider :rules="{numeric:true,required:true, min_value: 1, max_value: 999999999 }"
                                        v-slot="{errors, failedRules}">
                      <v-text-field
                          :error-messages="$translatedErrorMessages(failedRules,'financingAmountApproved')"
                          label="Financing Amount Approved"
                          prefix="RM"
                          v-model="editApplicationItem.financing_amount_approved">
                      </v-text-field>
                    </ValidationProvider>
                  </v-skeleton-loader>
                  <v-skeleton-loader
                      :loading="loadingFilterData"
                      transition="scale-transition"
                      type="list-item-two-line">
                    <ValidationProvider :rules="{numeric:true,required: true, min_value: 1, max_value: 180 }"
                                        v-slot="{errors, failedRules}">
                      <v-text-field
                          :error-messages="$translatedErrorMessages(failedRules,'tenureApproved')"
                          label="Tenure Approved" suffix="Months"
                          v-model="editApplicationItem.tenure_approved">
                      </v-text-field>
                    </ValidationProvider>
                  </v-skeleton-loader>
                </div>
              </form>
              <v-card-actions align="right">
                <v-spacer></v-spacer><v-btn @click="applicationStatusDialog=false" dark color="#49abad">Cancel</v-btn>
                <v-skeleton-loader :loading="loadingFilterData" transition="scale-transition"
                                   type="button">
                  <v-btn @click="passes(updateApplicationStatus)" class="ml-4" color="#49abad" dark>
                    Save
                  </v-btn>
                </v-skeleton-loader>
              </v-card-actions>
            </ValidationObserver>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog max-width="700" persistent v-model="generateScoreDialog">
        <v-card>
          <v-card-title class="headline">Generate Score</v-card-title>
          <v-card-text>
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field label="Gender" readonly
                                  v-model="editedItem.gender_label"></v-text-field>
                  </v-col>

                                    <v-col cols="12" md="4">
                                        <v-text-field label="Identification Number (ID)" readonly
                                                      v-model="editedItem.id_number"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field label="Date of Commencement" readonly
                                                      v-model="editedItem.formatted_commencement_date"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <v-text-field label="Malaysian Owned" readonly
                                                      v-model="editedItem.malaysian_owned">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field label="Paid-up Capital Amount" readonly
                                                      v-model="editedItem.paid_up_capital"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field label="Business Size" readonly
                                                      v-model="editedItem.business_size"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <v-text-field label="Nature Of Business" readonly
                                                      v-model="editedItem.business_category_label"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field label="Years of Industry Experience" readonly
                                                      v-model="editedItem.industry_experience"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field label="Financing Amount Applied" prefix="RM" readonly
                                                      v-model="editedItem.loan_amount"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <v-text-field label="Tenure Applied" readonly suffix="Months"
                                                      v-model="editedItem.tenure_applied"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field label="Number of full-time employee" readonly
                                                      v-model="editedItem.employees_count"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field label="Annual Sales" readonly
                                                      v-model="editedItem.annual_sales"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <v-text-field label="Annual Profit" readonly
                                                      v-model="editedItem.annual_profit"></v-text-field>
                                    </v-col>
                                  <v-col cols="12" md="4">
                                    <v-text-field rows="2" label="CTOS/CCRIS Rating" readonly
                                                v-model="editedItem.ctos_rating"></v-text-field>
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <v-text-field label="Credit Bureau Rating" readonly
                                                  v-model="editedItem.cbr_rating"></v-text-field>
                                  </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        Are you sure you want to generate GFI scores for this issuer?
                        <br/>Please note that you will not be able to change the issuer details after
                        scores have been generated.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="generateScoreDialog=false" dark color="#49abad" right>Cancel</v-btn>
                        <v-btn @click="sendGenerateScoreReqeust" class="mr-4" color="#49abad" dark right>Yes</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
        <v-snackbar
                :right="'right'"
                :timeout=4000
                :top="'top'"
                color="success"
                v-model="updated">
            Successfully Updated.
        </v-snackbar>
        <v-snackbar
                :right="'right'"
                :timeout=4000
                :top="'top'"
                color="success"
                v-model="generateScoreSnackbar">
            Successfully Triggered Generate Scores.
        </v-snackbar>
        <v-snackbar
                :right="'right'"
                :timeout=2000
                :top="'top'"
                color="success"
                v-model="deletedSnackbar">
            Successfully Removed.
        </v-snackbar>
        <v-snackbar :bottom="true" :right="true" :timeout="6000" :vertical="true" color="info"
                    v-model="reportDownloadError">
            <span v-html="$t('msg.report_unavailable')"></span>
            <v-btn @click="reportDownloadError = false" dark text v-html="$t('msg.close_label')"></v-btn>
        </v-snackbar>
        <v-snackbar :bottom="true" :right="true" :timeout="6000" :vertical="true" color="info"
                    v-model="exportDataDownloadError">
            <span v-html="$t('msg.export_unavailable')"></span>
            <v-btn @click="exportDataDownloadError = false" dark text v-html="$t('msg.close_label')"></v-btn>
        </v-snackbar>
      <v-snackbar
          v-model="endDateSnackBar"
          :multi-line="true"
          :top="true"
          :timeout="3000"
          color="#81c342"
      >
        Please select Start Date First

        <template v-slot:action="{ attrs }">
          <v-btn
              color="black"
              dark
              text
              v-bind="attrs"
              @click="endDateSnackBar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>
</template>
<script>
    import {dataServices, downloadFileService} from "../../services/index";
    import {ValidationProvider, ValidationObserver} from 'vee-validate';
    import debounce from 'lodash/debounce'
    import fileSaver from 'file-saver'

    export default {
        name: 'UserList',
        components: {
            ValidationProvider,
            ValidationObserver
        },
        props: {
            userType: {
                type: String,
                default: 'SME',
                required: true
            }
        },
        data() {
            return {
                renderEditForm: true,
                reportDownloadError: false,
                exporting: false,
                exportDataDownloadError: false,
                hideColumn: false,
                loadingFilterData: true,
                tableDataLoading: true,
                loading: false,
                selectedSchedule: '',
                appliedFilters: {
                    scheme: '',
                    amount: '',
                    status: '',
                    finAppStatus: '',
                    startDate: '',
                    endDate: '',
                    branch: ''
                },
                profile: {},
                results: {},
                editedItem: {},
                editedCommencementDate: '',
                editApplicationItem: {},
                schedules: [],
                table: {
                    tableData: [],
                    totalLength: 0
                },
                schemeDropdownData: [],
                amountRangeDropdownData: [],
                statusDropdownData: [],
                yearDropdownData: [],
                applicationStatusDropdownData: [],
                branchDropdownData: [],
                editGenderFilterDropdownData: [],
                editBusinessCategoryDropdownData: [],
                editEthnicityDropdownData: [],
                malaysianOwnedItems: [
                    {text: 'Yes', value: 'Yes'},
                    {text: 'No', value: 'No'}
                ],
                businessSizeItems: [
                    {text: 'Micro', value: 'Micro'},
                    {text: 'Small', value: 'Small'},
                    {text: 'Medium', value: 'Medium'},
                    {text: 'Large', value: 'Large'}
                ],
                date: new Date().toISOString().substr(0, 10),
                newDate: '',
                menu: false,
                modal: false,
                menu2: false,
                menu1: false,
                search: '',
                dialog: false,
                applicationStatusDialog: false,
                appliedDialog: false,
                deletedDialog: false,
                generateScoreDialog: false,
                updated: false,
                deletedSnackbar: false,
                generateScoreSnackbar: false,
                endDateSnackBar: false,
                moreThanTwo: false,
                requestDataArray: [''],
                items: [
                    {text: 'Home', disabled: true, href: 'breadcrumbs_dashboar'},
                    {text: 'Manage', disabled: true, href: 'breadcrumbs_link_1'}
                ],
                filterBoxLabel: {
                    scheme: this.$t('msg.scheme_label'),
                    amount: this.$t('msg.amount_range_label'),
                    gfiStatus: this.$t('msg.gfi_status_label'),
                    finAppStatus: this.$t('msg.financing_application_status_label'),
                    startDate: this.$t('msg.start_date_label'),
                    endDate: this.$t('msg.end_date_label'),
                    branch: this.$t('msg.branch_label')
                },
                headers: [
                    {
                        position: 1,
                        text: this.$t('msg.sl_no'),
                        align: 'left',
                        selectedCheckbox: true,
                        toggle: false,
                        value: 'slno'
                    },
                    {
                        position: 2,
                        text: this.$t('msg.id_number'),
                        align: 'left',
                        selectedCheckbox: true,
                        toggle: false,
                        value: 'id_number'
                    },
                    {
                        position: 3,
                        text: this.$t('msg.financing_amount_requested'),
                        align: 'left',
                        selectedCheckbox: true,
                        toggle: false,
                        value: 'loan_amount'
                    },
                    {
                        position: 4,
                        text: this.$t('msg.gfi_completion_date'),
                        align: 'left',
                        selectedCheckbox: true,
                        toggle: false,
                        value: 'test_finish_time'
                    },
                    {
                        position: 5,
                        text: this.$t('msg.gfi_status'),
                        align: 'center',
                        selectedCheckbox: true,
                        toggle: false,
                        value: 'completion_status'
                    },
                    {
                        position: 6,
                        text: this.$t('msg.update_details'),
                        align: 'center',
                        selectedCheckbox: true,
                        toggle: false,
                        value: 'details'
                    },
                    {
                        position: 7,
                        text: this.$t('msg.gfi_scoring'),
                        align: 'center',
                        selectedCheckbox: true,
                        toggle: false,
                        value: 'scoring'
                    },
                    {
                        position: 8,
                        text: this.$t('msg.application_status'),
                        align: 'center',
                        selectedCheckbox: true,
                        toggle: false,
                        value: 'applicationStatus'
                    },
                    {
                        position: 9,
                        text: this.$t('msg.gfi_rating'),
                        value: 'test_taker_score_overall_rating',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {position: 10, text: this.$t('msg.report'), value: 'report', selectedCheckbox: true, toggle: false},
                ],
                checkItemArray: [],
                clickedItem: {},
                pagination: {
                    itemsPerPage: 10,
                    itemPerPageOptions: [10]
                }, filterBox: {
                    loanAmount: '',
                    gfiStatus: '',
                    startDate: '',
                    endDate: '',
                    formattedStartDate: ''
                }
            }
        },
        methods: {
            showColumn: function (col) {
                return this.headers.find(h => h.value === col).selected
            },
            hideColumnData: function () {
                this.hideColumn = !this.hideColumn
            },
            prepareDataForRequest: function () {
                return {
                    pageSize: this.pagination.itemsPerPage,
                    pageNumber: this.pagination.page,
                    searchText: this.search,
                    amount: this.filterBox.loanAmount,
                    status: this.filterBox.gfiStatus,
                    startDate: this.filterBox.startDate,
                    endDate: this.filterBox.endDate,
                    financeType: this.userType
                }
            },
            getDataFromApi: function () {
                console.log('data for' + this.userType)
                let data = this.prepareDataForRequest()
                dataServices.getDataForCustomers(data).then(response => {
                    this.table.tableData = response.dataResponse.resultData.table_content
                    this.table.totalLength = response.dataResponse.resultData.total_rows
                    this.tableDataLoading = false
                })
            },
            getDropDownData: function () {
                console.log('user type ' + this.userType)
                if (this.userType === 'MIKRO') {
                    dataServices.getMikroDataForFilters().then(response => {
                        this.populateDropdownData(response)
                        this.loadingFilterData = false
                    })
                } else if (this.userType === 'SME') {
                    dataServices.getSmeDataForFilters().then(response => {
                        this.populateDropdownData(response)
                        this.loadingFilterData = false
                    })
                }
            },
            populateDropdownData: function (response) {
                if (null != response.dataResponse.schemeDropDown) {
                    this.schemeDropdownData = response.dataResponse.schemeDropDown
                }
                if (null != response.dataResponse.amountRangeDropDown) {
                    this.amountRangeDropdownData = response.dataResponse.amountRangeDropDown
                }
                if (null != response.dataResponse.statusDropDown) {
                    this.statusDropdownData = response.dataResponse.statusDropDown
                }
                if (null != response.dataResponse.applicationStatusDropDown) {
                    this.applicationStatusDropdownData = response.dataResponse.applicationStatusDropDown
                }
                if (null != response.dataResponse.branchDropDown) {
                    this.branchDropdownData = response.dataResponse.branchDropDown
                }
            },

            getEditFilterDropdownData: function () {
                dataServices.getDataForEditFilters().then(response => {
                    if (null != response.dataResponse.editGenderDropDownData) {
                        this.editGenderFilterDropdownData = response.dataResponse.editGenderDropDownData
                    }
                    if (null != response.dataResponse.editBusinessDropDownData) {
                        this.editBusinessCategoryDropdownData = response.dataResponse.editBusinessDropDownData
                    }
                    if (null != response.dataResponse.editEthnicityDropDownData) {
                        this.editEthnicityDropdownData = response.dataResponse.editEthnicityDropDownData
                    }
                    this.loading = false
                })
            },
            updateUserInformation: function () {
                console.log(this.editedItem.commencement_date)
                dataServices.editUserInformation(this.editedItem).then(response => {
                    console.log(response)
                    this.paginate()
                    this.updated = true
                    this.dialog = false
                }).catch(error => {
                    console.log('Error' + error)
                })
            },
            updateCustomerApplicationStatus: function () {
                dataServices.editApplicationStatus(this.editApplicationItem).then(response => {
                    console.log(response)
                    this.paginate()
                    this.updated = true
                    this.applicationStatusDialog = false
                }).catch(error => {
                    console.log('error' + error)
                })
            },
            editItem: function (item) {
                this.dialog = true
                this.editedItem = Object.assign({}, item)
                if (this.editedItem.commencement_date) {
                    const [year, month, day] = this.editedItem.commencement_date.substr(0, 10).split('-')
                    this.editedCommencementDate = `${day}-${month}-${year}`
                } else
                    this.editedCommencementDate = ''
                this.getEditFilterDropdownData()
            },
            editApplicationStatus: function (item) {
                this.applicationStatusDialog = true
                this.editApplicationItem = Object.assign({}, item)
            },
            updatedItem: function () {
                this.updateUserInformation()
            },
            updateApplicationStatus: function () {
                this.updateCustomerApplicationStatus()
            },
            filterData: function () {
                this.appliedFilters.amount = this.filterBox.loanAmount
                this.appliedFilters.status = this.filterBox.gfiStatus
                this.appliedFilters.startDate = this.filterBox.startDate
                this.appliedFilters.endDate = this.filterBox.endDate
                this.pagination.page = 1
                this.paginate()
            },
            resetFilters: function () {
                this.filterBox.loanAmount = ''
                this.filterBox.gfiStatus = ''
                this.filterBox.startDate = ''
                this.filterBox.endDate = ''
                this.pagination.page = 1
                this.paginate()
            },
            paginate: function () {
                this.tableDataLoading = true
                this.getDataFromApi()
            },
            generateScore: function (item) {
                this.generateScoreDialog = true
                this.editedItem = Object.assign({}, item)
            },
            sendGenerateScoreReqeust: function () {
                dataServices.scoreCustomer(this.editedItem).then(response => {
                    console.log(response)
                    this.paginate()
                    this.generateScoreDialog = false
                    this.generateScoreSnackbar = true
                }).catch(error => {
                    console.log('Error' + error)
                })
            },
            downloadReport: function (ttid, idNumber, reportType) {
                this.reportDownloadError = false
                let loaderString = ttid + '-' + idNumber + '-' + reportType
                if (this.requestDataArray.indexOf(loaderString) < 0) {
                    this.requestDataArray.push(loaderString)
                }
                downloadFileService.downloadReport({id: ttid})
                    .then(response => {
                        if (response) {
                            fileSaver.saveAs(response, idNumber + '.pdf')
                        }
                        this.requestDataArray.splice(this.requestDataArray.indexOf(loaderString), 1)
                        this.loading = false
                    }).catch(error => {
                    this.loading = false
                    this.requestDataArray.splice(this.requestDataArray.indexOf(loaderString), 1)
                    this.reportDownloadError = true
                    console.log('loggin response ' + error)
                })
            },
            downloadCustomerReport: function (ttid, idNumber, reportType) {
                this.reportDownloadError = false
                let loaderString = ttid + '-' + idNumber + '-' + reportType
                if (this.requestDataArray.indexOf(loaderString) < 0) {
                    this.requestDataArray.push(loaderString)
                }
                downloadFileService.downloadCustomerReport({id: ttid})
                    .then(response => {
                        if (response) {
                            fileSaver.saveAs(response, idNumber + '.pdf')
                        }
                        this.requestDataArray.splice(this.requestDataArray.indexOf(loaderString), 1)
                        this.loading = false
                    }).catch(error => {
                    this.loading = false
                    this.requestDataArray.splice(this.requestDataArray.indexOf(loaderString), 1)
                    this.reportDownloadError = true
                    console.log('loggin response ' + error)
                })
            },
            checkArray: function (ttid, idNumber, reportType) {
                return this.requestDataArray.indexOf(ttid + '-' + idNumber + '-' + reportType) < 0
            },
            recordTicks: function () {
                let selectedColumns = this.headers
                    .filter(header => (header.toggle && header.selectedCheckbox))
                    .map(function (header) {
                        return header.position
                    })
                this.$cookies.set('gfi-starter-plus-' + this.userType, JSON.stringify(selectedColumns))
            },
            clear: function () {

                this.renderEditForm = false

                this.$nextTick(() => {
                    this.renderEditForm = true;
                });
                this.dialog = false
            }
        },
        computed: {
            filteredHeaders: function () {
                let role = this.$store.state.home.user.role
                let columnsForRole = this.headers.filter(function (e) {
                    if (!e.roles || e.roles.length === 0) {
                        return true
                    } else if (e.roles.includes(role)) {
                        return true
                    } else {
                        return false
                    }
                });
                return columnsForRole.filter(h => h.selectedCheckbox)
            },
            isUserAuthenticated() {
                return this.$store.state.home.authenticated
            },
          showTableHeading() {
            return this.$store.state.home.user.products.length > 1
          }
        },
        created() {
            this.getDropDownData()
            this.getDataFromApi()
            if (this.$cookies.get('gfi-starter-plus-' + this.userType)) {
                let selectedColumns = JSON.parse(this.$cookies.get('gfi-starter-plus-' + this.userType))
                for (let i = 0; i < this.headers.length; i++) {
                    if (selectedColumns.includes(this.headers[i].position)) {
                        this.headers[i].selectedCheckbox = true
                    }
                }
            }
        },
        watch: {
            'editedItem.commencement_date': function () {
                if (this.editedItem.commencement_date) {
                    const [year, month, day] = this.editedItem.commencement_date.substr(0, 10).split('-')
                    this.editedCommencementDate = `${day}-${month}-${year}`
                } else
                    this.editedCommencementDate = ''
            },
            editedCommencementDate: function (newCommencementDate) {
                if (!newCommencementDate) {
                    this.editedItem.commencement_date = null
                }
            },
            search: debounce(function (newValue) {
                if (newValue === '') {
                    this.getDataFromApi()
                }
            }, 900),
            userType: function () {
                console.log("changed")
                this.getDropDownData()
                this.resetFilters()
                this.$forceUpdate();
            },
            'filterBox.startDate': function () {
                let date = new Date(this.filterBox.startDate)
                date.setFullYear(date.getFullYear(), 11, 31)
                if (date.getFullYear() < new Date().getFullYear()) {
                    this.newDate = date.toJSON()
                } else {
                    this.newDate = this.date
                }

                if (this.filterBox.startDate === '' || this.filterBox.startDate === null){
                  this.filterBox.endDate = ''
                  this.newDate = this.date
                }

    },
    'filterBox.endDate': function () {
        if (this.filterBox.startDate === '' || this.filterBox.startDate === null){
          if (this.filterBox.endDate !== ''){
            this.filterBox.endDate = ''
            this.endDateSnackBar = true
          }
        }
    }
  },
}
</script>
<style>
    .containerStyling {
        margin-top: 0px;
        margin-bottom: 0px;
    }

    .customersTablePadding {
        padding-top: 0px;
        padding-bottom: 100px;
    }

    .v-application .primary--text {
        color: #81c342 !important;
        caret-color: #81c342 !important;
    }
</style>/